/**
 * Applies a user's saved TUNE (`user/tabletune/<key>`) to the declared columns.
 *
 * A faithful copy of `mergeColumnsAndTunedFields` in `generic/SmartMateriaUITable.jsx`, quirks
 * included, so a user who tuned today's details table sees the same columns in this one:
 * - a saved column is hidden when `!show`, and goes to its saved `order` when shown. A shown column
 *   whose saved order is falsy (0, null) is pushed to the end, like a hidden one;
 * - a declared column that is not saved is shown, with `order` = declaration index + 1, which can
 *   tie with a saved order;
 * - a saved field that is no longer declared is dropped;
 * - ties keep the declaration order (`Array.prototype.sort` is stable).
 *
 * @param {Array<Object>} columns Declared columns, each with a `field`
 * @param {Array<{ name: string, show: boolean, order: number }>} fields Saved TUNE fields
 * @returns {Array<Object>} The columns with `hide` and `order` set, sorted by `order`
 */
const mergeColumnsAndTunedFields = (columns, fields) => {
  const mergedColumns = columns.map((column, index) => {
    const customField = fields.find(item => item.name === column.field)
    if (customField) {
      return { ...column, hide: !customField.show, order: customField.order && customField.show ? customField.order : Infinity }
    }
    return { ...column, hide: false, order: index + 1 }
  })
  return mergedColumns.sort((a, b) => a.order - b.order)
}

/**
 * The TUNE fields the dialog edits and the server stores, built from merged columns.
 * @param {Array<Object>} columns Merged columns
 * @returns {Array<{ label: string, name: string, show: boolean, order: number }>}
 */
const tuneFieldsFromColumns = (columns) => columns.map((column) => ({
  label: column.tuneLabel ? column.tuneLabel : column.name,
  name: column.field,
  show: !column.hide,
  order: column.order
}))

export { mergeColumnsAndTunedFields, tuneFieldsFromColumns }
